import React from 'react'
import SearchContentInput from "./search-content-input";
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';



const NoProductWindow = () => {
  const { t } = useTranslation(['data'])

    const location = useLocation();

    const getRoute = location.pathname.split("/").filter((el) => el);
    

  return (


    <div className='noProduct-container'>
        <div className='image'><img src="https://ferrero-es.playmotiv.cloud/wp-content/uploads/sites/2/2022/02/error-image.png"></img></div>
        <div className='content'>
            <span>{t('emptyBuscadorSpanOne')}</span>
            <span>{t('emptyBuscadorSpanTwo')}</span>

            <SearchContentInput route={getRoute} />

        </div>

    </div>


  )
}


export default NoProductWindow;
